import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { AddAndExtendActions } from 'components';
import { User } from 'types';

import { AchievementEmptyState, AchievementsList } from '../../components';
import { EmptyStateW } from '../AchievementsPage/styled';
import { useProfileAchievements } from './hooks';
import { ContainerW, Header, Title } from './styled';

interface ProfileAchievementsProps {
  employeeId: string;
  usersList: User[];
}

export function ProfileAchievements({
  employeeId,
  usersList,
}: ProfileAchievementsProps): ReactElement {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { achievements, isAchievementsList, addAchievementLink, viewAchieventsLink } =
    useProfileAchievements({
      employeeId,
    });

  return (
    <ContainerW>
      <Header>
        <Title>{t('profile.achievements.title')}</Title>
        <AddAndExtendActions addIconLink={addAchievementLink} />
      </Header>

      {isAchievementsList ? (
        <AchievementsList
          data={achievements}
          employeeId={employeeId}
          usersList={usersList}
          isProfilePreview
          viewAllLink={viewAchieventsLink}
        />
      ) : (
        <EmptyStateW>
          <AchievementEmptyState
            addAchievementLink={addAchievementLink}
            onAddAchievement={() => navigate(addAchievementLink)}
          />
        </EmptyStateW>
      )}
    </ContainerW>
  );
}
